module.exports = __webpack_public_path__ + "img/mg-1.aaebd979.png";